/*
 * Provide a generic lightbox search/result picker "control".
 * SDK v5.0+
 * 
 * Enable this functionality by
 * TODO!
 */

/* Supported details
 * 			<fieldElement type="hidden" uniqueId="TestPicker-SearchResultPicker" id="SP.TestPicker" />
 * 			<fieldElement type="hidden" uniqueId="TestPicker-WindowTitle"  id="SP.TestPicker-WindowTitle" defaultValue="Agency Search" />
 * 			<fieldElement type="hidden" uniqueId="TestPicker-DisplayOnLoad"  id="SP.TestPicker-DisplayOnLoad" defaultValue="true" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-SearchHeader" id="SP.TestPicker-SearchHeader" defaultValue="Search Header" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-SearchFooter" id="SP.TestPicker-SearchFooter" defaultValue="Search Footer" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-SearchFieldLabels" id="SP.TestPicker-SearchFieldLabels" defaultValue="Name:,City:,State:,Zip:,Phone Number:" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-SearchFields" id="SP.TestPicker-SearchFields" defaultValue="HIDDEN(LegalEntity),TestPicker-SearchName,TestPicker-SearchCity,ApplicantAddressState,TestPicker-SearchZip,TestPicker-SearchPhone" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-ResultHeader" id="SP.TestPicker-ResultHeader" defaultValue="Result Header" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-ResultFooter" id="SP.TestPicker-ResultFooter" defaultValue="Result Footer" />
 *			<fieldElement type="hidden" uniqueId="TestPicker-ResultList" id="SP.TestPicker-ResultList" defaultValue="[LegalEntity=1|ApplicantAddressLine1=blah blah|ApplicantAddressCity=somecity|ApplicantAddressState=SS|ApplicantAddressZip=00000][LegalEntity=3|ApplicantAddressLine1=yakkity yakkity|ApplicantAddressCity=anothercity|ApplicantAddressState=TT|ApplicantAddressZip=11111]"/>
 *			<fieldElement type="hidden" uniqueId="TestPicker-ResultColumnHeaders" id="SP.TestPicker-ResultColumnHeaders" defaultValue="Select,Address,City,State,Zip"/>
 *			<fieldElement type="hidden" uniqueId="TestPicker-ResultColumns" id="SP.TestPicker-ResultColumns" defaultValue="Select,ApplicantAddressLine1,ApplicantAddressCity,ApplicantAddressState,ApplicantAddressZip"/>
 *			<fieldElement type="message" uniqueId="TestPicker-Link" id="TestPicker-Link" encode="false">
 *				&lt;a href=javascript:searchResultPicker.displaySearchResultPicker('TestPicker');&gt;Select Testing Result&lt;/a&gt;
 *			</fieldElement>
 */

// Setup the namespace for this logic
var searchResultPicker = searchResultPicker || {};

searchResultPicker.initialize = function() {
	ap.consoleInfo("searchResultPicker initialize!");
	page.searchResultPickerSetIPDTRFieldFocus = page.setIPDTRFieldFocus;
	
	// When all pending IPDTR calls are complete, and IPDTRJanitor runs, that function   
	// is the *only* caller that executes through setIPDTRFieldFocus.  When the janitor 
	// is done working, check each search result picker to see if it was triggered for
	// a search, and run its search result function 
	page.setIPDTRFieldFocus = function() {
		ap.consoleInfo('SearchResultPicker: setIPDTRFieldFocus Start');
		if (typeof page.searchResultPickerSetIPDTRFieldFocus === "function")
		{
			ap.consoleInfo('SearchResultPicker: Call searchResultPickerSetIPDTRFieldFocus');
			page.searchResultPickerSetIPDTRFieldFocus();
		}
		
		if (searchResultPicker.pickerList) {
			for (var index=0; index<searchResultPicker.pickerList.length; index++) {
				if (searchResultPicker.pickerList[index].isSearching) {
					searchResultPicker.pickerList[index].searchResultProcess();
					break;
				}
			}
		}
		ap.consoleInfo('SearchResultPicker: setIPDTRFieldFocus End');
	};
	
	// If this is the roster listing page, don't display.  Any other page is fair game for display of the search result picker.
	if (page && page.type=="roster")
		return;
	
	var displaySearchResultPickerOnLoad = "";
	var pickerFields = $("form input");

	//Store all SearchResultPicker objects in the Page object as an array for easy access later
	searchResultPicker.pickerList = new Array();
	
	for (var index = 0; index < pickerFields.length; index++) {
		var pickerElement = pickerFields[index];
		var pickerId = pickerElement.id;
		var stringMatchIndex = pickerId.search("-SearchResultPicker");
		if (stringMatchIndex == -1)
			continue;
		ap.consoleInfo("SearchResultPicker field found! :: " + pickerId);
		pickerId = pickerId.substr(0, stringMatchIndex);
		ap.consoleInfo("SearchResultPicker base id :: " + pickerId);
		var newPicker = new searchResultPicker.picker(pickerId);
		newPicker.initialize();
		searchResultPicker.pickerList.push(newPicker);
		if (newPicker.displayOnLoad && displaySearchResultPickerOnLoad=="")
			displaySearchResultPickerOnLoad = pickerId;
	}
	if (displaySearchResultPickerOnLoad!="")
		searchResultPicker.displaySearchResultPicker(displaySearchResultPickerOnLoad);
	
};


// Define a couple functions to get at the SearchResultPicker objects, either to 
//   directly display them, or to acquire them for manual use.
searchResultPicker.getSearchResultPicker = function(pickerId) {
	for (var index=0; index<searchResultPicker.pickerList.length; index++) {
		if (searchResultPicker.pickerList[index].pickerId == pickerId) {
			return searchResultPicker.pickerList[index];
		}
	}
	return null;
};


searchResultPicker.displaySearchResultPicker = function() {
	var picker = searchResultPicker.getSearchResultPicker(arguments[0]);
	if (picker!=null) {
		picker.display();
	} else {
		ap.consoleInfo("SearchResultPicker not found! :: " + arguments[0]);
	}
};


searchResultPicker.displaySearchResultPickerNoResults = function() {
	var picker = searchResultPicker.getSearchResultPicker(arguments[0]);
	if (picker!=null) {
		var field = page.getField(arguments[0]+"-ResultList");
		if (field) {
			field.setValue("");
		}
		picker.resultList = "";
		picker.display();
	} else {
		ap.consoleInfo("SearchResultPicker not found! :: " + arguments[0]);
	}		
};


searchResultPicker.picker = function(pickerId) {
	this.pickerId = pickerId;
	this.isSearching = false;

	this.initialize = function() {
		this.windowTitle = this.getFieldValue(pickerId+"-WindowTitle");
		this.searchHeader = this.getFieldValue(pickerId+"-SearchHeader");
		this.searchFooter = this.getFieldValue(pickerId+"-SearchFooter");
		this.searchFieldLabels = this.getFieldValue(pickerId+"-SearchFieldLabels", ",");
		this.searchFields = this.getFieldValue(pickerId+"-SearchFields", ",");
		if (this.searchFieldLabels.length != this.searchFieldLabels.length) {
			this.searchFieldLabels = this.searchFields = "";
			ap.consoleInfo("Error initializing " + pickerId + "!!!  searchFieldLabels count doesn't match searchFields count");
		}
		this.resultList = this.getFieldValue(pickerId+"-ResultList");
		this.noResultsMessage = this.getFieldValue(pickerId+"-NoResultsMessage");
		if (this.noResultsMessage=="")
			this.noResultsMessage = "No matching results.";
		this.resultHeader = this.getFieldValue(pickerId+"-ResultHeader");
		this.resultFooter = this.getFieldValue(pickerId+"-ResultFooter");
		this.resultColumns = this.getFieldValue(pickerId+"-ResultColumns", ",");
		this.resultColumnHeaders = this.getFieldValue(pickerId+"-ResultColumnHeaders", ",");
		if (this.resultColumnHeaders.length != this.resultColumns.length) {
			this.resultColumnHeaders = this.resultColumns = "";
			ap.consoleInfo("Error initializing " + pickerId + "!!!  resultColumnHeaders count doesn't match resultColumns count");
		}

		var $body = $("body");
		var htmlNodes = $.parseHTML(this.generateHtml());
		$body.append(htmlNodes);
		
		// Set a flag if this picker has results and is tagged to be displayed on load
		if (this.resultList && this.resultList.length>0 && 
				this.getFieldValue(pickerId+"-DisplayOnLoad")=="true")
			this.displayOnLoad = true;
		else
			this.displayOnLoad = false;
	};
	
	
	// The primary method available for use in this object - produce and display the popup window!
	this.display = function() {
		ap.consoleInfo("Display " + pickerId + "!!!");
		
		// If there are results to add to the html to be displayed on load, this is where that magic is kicked off
		this.searchResultProcess();
		
		// Insert the html as the first argument, and then call overlib to display the popup
		$("#"+this.pickerId).modal('show');
		
		// Ability to override some/all search submit handling by defining a function:
		//   page.customSearchResultPickerSearchSubmit = function(pickerId) { ... };
		var customFunction = this.customSearchResultPickerPostDisplay;
		if (typeof customFunction === "function") {
			ap.consoleInfo("Calling customSearchResultPickerPostDisplay!!!");
			customFunction(this);
		}
	};
	
	
	this.searchSubmit = function () {
		ap.consoleInfo("searchSubmit: " + this.pickerId + "!!!");
		// Ability to override some/all search submit handling by defining a function:
		//   page.customSearchResultPickerSearchSubmit = function(pickerId) { ... };
		var customFunction = this.customSearchResultPickerSearchSubmit;
		if (typeof customFunction === "function") {
			ap.consoleInfo("Calling customSearchResultPickerSearchSubmit!!!");
			if (!customFunction(this))
				// A false return means don't continue processing
				return;
		}
		
		var field = page.getField(this.pickerId+"-SearchResultPicker");
		if (field) {
			var requestString = this.prepareRequestString();
			ap.consoleInfo("searchSubmitRequestString: " + requestString);
			this.isSearching = true;
			field.setValue(requestString);
		}
	};
	
	
	this.searchResultProcess = function () {
		ap.consoleInfo("Start searchResultProcess: " + this.pickerId);

		// Ability to override some/all search submit handling by defining a function:
		//   page.customSearchResultPickerSearchResultProcess = function(pickerId) { ... };
		var customFunction = page.customSearchResultPickerSearchResultProcess;
		if (typeof customFunction === "function") {
			ap.consoleInfo("Calling customSearchResultPickerSearchResultProcess!!!");
			if (!customFunction(this))
				// A false return means don't continue processing
				return;
		}
		
		// Process the response into the html for the table
		this.resultList = this.getFieldValue(pickerId+"-ResultList");
		var resultsHtml = this.generateResultsHtml();
		
		// Now insert the html into the table, replacing any prior html in the table 
		var $tableBody = $("#"+pickerId+" table.popupTable tbody");
		if ($tableBody) {
			$tableBody.empty();
			if (resultsHtml) {
				var htmlNodes = $.parseHTML(resultsHtml);
				$tableBody.append(htmlNodes);
			}
		} else {
			ap.consoleInfo("\"#"+pickerId +" table.popupTable tbody\" evaluated to undefined!");
		}
		this.isSearching = false;
		ap.consoleInfo("End searchResultProcess: " + this.pickerId);
	};
	
	
	this.selectResult = function (resultIndex) {
		var resultList = this.parseResultsString();
		var resultNameValues = this.parseResultData(resultList[resultIndex]);

		// Ability to override some/all search submit handling by defining a function:
		//   page.customSearchResultPickerSelectResult = function(picker, resultIndex, resultNameValues) { ... };
		var customFunction = page.customSearchResultPickerSelectResult;
		if (typeof customFunction === "function") {
			ap.consoleInfo("Calling customSearchResultPickerSelectResult!!!");
			if (!customFunction(this, resultIndex, resultNameValues)) {
				// A false return means don't continue processing
				return;
			}
		}
		
		// Do default processing!
		ap.consoleInfo("selectResult: " + pickerId + ", " + resultIndex + "!!!");
		
		// Copy the data into the destination fields (per uniqueId)
		for (name in resultNameValues) {
			var field = page.getField(name);
			if (field) {
				var value = resultNameValues[name];
				if (!value)
					value = "";
				if (field.getValue() != value) {
					field.setValue(value);
					var triggerReadOnlyLogic = false;
					if (field.readOnly) {
						triggerReadOnlyLogic = true;
						field.setReadOnly(false);
					}
					// Steal logic from Field.paint() in ap_javascript_objects.js to trigger format mask to properly format/display the newly set value
//					if (field.fieldFormatMask && !field.interestLevel.isExcluded() && !field.parentFieldset.isExcluded()) {
//						field.fieldFormatMask.caret(0, field.fieldFormatMask.options.mask.length);
//					}
					if(field.hasFormatMask === true && !field.interestLevel.isExcluded() && !field.parentFieldset.isExcluded()){
						field.applyFormatmask();
					}
					if (triggerReadOnlyLogic) {
						field.setReadOnly(true);
					}
				}
			}
		}
		
		// Hide the modal window!
		$("#"+this.pickerId).modal('hide');
	};
	
	
	// Function not really intended to be called directly, produces the HTML for overlib to display
	this.generateHtml = function () {
		var theHtml = "";

		theHtml += "<div class='modal fade' data-backdrop='static' data-keyboard='false' id='"+this.pickerId+"'";
		theHtml += "    tabindex='-1' role='dialog' aria-labelledby='"+this.pickerId+"' aria-hidden='true'>";
		theHtml +=     "<div class='modal-dialog'>";
		theHtml +=         "<div class='modal-content'>";
		theHtml +=             "<div class='modal-header'>";
		theHtml +=                 "<button type='button' class='close' data-dismiss='modal' aria-hidden='true' title='Close this window'>&times;</button>";
		theHtml +=                 "<h2 class='modal-title'>"+this.windowTitle+"</h2>";
		theHtml +=             "</div>";
		theHtml +=             "<div class='modal-body'>";
		
		if (this.searchFieldLabels && this.searchFields &&
				this.searchFieldLabels.length > 0 && 
				this.searchFields.length > 0) {
			theHtml += "<div class='searchSection'>";
			if (this.searchHeader && this.searchHeader.length>0) {
				theHtml += "  <div id='searchHeader'>";
				theHtml += this.searchHeader;
				theHtml += "  </div>";
			}
			theHtml += "  <form id='searchForm'>";
			
			theHtml += this.generateSearchFieldHtml();

			theHtml += "    <div class='searchFormSubmit'>";
			theHtml += "      <input name='searchFormButton' id='searchFormButton' type='button' value='Search' onclick='searchResultPicker.getSearchResultPicker(\""+this.pickerId+"\").searchSubmit()' />";
			theHtml += "    </div>";
			theHtml += "  </form>";
			if (this.searchFooter && this.searchFooter.length>0) {
				theHtml += "  <div class='searchFooter'>";
				theHtml += this.searchFooter;
				theHtml += "  </div>";
			}
			theHtml += "</div>";
		}
		theHtml += "<div class='searchResults'>";
		if (this.resultHeader && this.resultHeader.length>0) {
			theHtml += "  <div class='resultHeader'>";
			theHtml += this.resultHeader;
			theHtml += "  </div>";
		}
		theHtml += "  <table width='100%' class='popupTable'>";
		theHtml += this.generateResultHeaderHtml();
		theHtml += "    <tbody>";
		theHtml += "    </tbody>";
		theHtml += "  </table>";
		if (this.resultFooter && this.resultFooter.length>0) {
			theHtml += "  <div class='resultFooter'>";
			theHtml += this.resultFooter;
			theHtml += "  </div>";
		}
		theHtml += "</div>";  // searchSection
		theHtml += "</div>";  // modal-body
		theHtml += "</div>";  // modal-content
		theHtml += "</div>";  // modal-dialog
		theHtml += "</div>";  // modal
		
		return theHtml;
	};

	
	this.generateSearchFieldHtml = function() {
		var theHtml = "";
		for (var index=0; index<this.searchFields.length; index++) {
			var fieldId = this.searchFields[index];
			var hiddenField = false;
			var resolvedId = this.resolveFieldId(fieldId);
			if (fieldId!=resolvedId) {
				hiddenField = true;
			}
			var element = document.getElementById(resolvedId);
			theHtml += "<div class='"+fieldId+"Section'>";
			if (element) {
				if (!hiddenField) {
// TODO: Probably need to check and do something about potential elements with duplicate ids, but for now it's working...
					theHtml += this.searchFieldLabels[index]+" ";
					theHtml += element.outerHTML;
				} else {
					// Hidden field!
					theHtml += "<input type='hidden' id='"+fieldId+"' value='"+element.value+"' />";
				}
			} else {
				theHtml += this.searchFieldLabels[index]+" ";
				theHtml += "<input type='text' id='"+fieldId+"' />";
			}
			theHtml += "</div>";
		}
		return theHtml;
	};

	
	this.resolveFieldId = function(fieldId) {
		var hiddenIndicator = fieldId.indexOf("HIDDEN(");
		if (hiddenIndicator>-1) {
			fieldId = fieldId.substr(hiddenIndicator+7);
			var endParen = fieldId.lastIndexOf(")");
			if (endParen>0)
				fieldId = fieldId.substr(0, endParen);
		}
		return fieldId;
	};
	
	this.generateResultHeaderHtml = function() {
		var theHtml = "";
		theHtml += "<thead><tr class='headerRow'>";
		for (var index=0; index<this.resultColumnHeaders.length; index++) {
			theHtml += "<th class='headerCell"+index+"'>"+this.resultColumnHeaders[index]+"</th>";
		}
		theHtml += "</tr></thead>";
		return theHtml;
	};
	
	
	// Format:
	//   [name=value|name=value|...][name=value|name=value|...]
	//   e.g. [TestPicker-ResultAddress=blah blah|TestPicker-ResultCity=somecity|TestPicker-ResultState=SS|TestPicker-ResultZip=00000][...]
	this.generateResultsHtml = function() {
		var theHtml = "";
		
		// Parse each result out of the full string, then parse the data values from 
		//   each result into an associative name-value array
		var resultList = this.parseResultsString();
		for (var resultIndex=0; resultIndex<resultList.length; resultIndex++) {
			var nameValues = this.parseResultData(resultList[resultIndex]);
			var rowType;
			//determine if this is an odd or even row
			if(resultIndex % 2) {
				rowType = "even";
			} else {
				rowType = "odd";
			}
			// Create the <tr></tr> with embedded <td></td> elements for each result
			theHtml += "<tr class='dataRow "+rowType+"' onclick='searchResultPicker.getSearchResultPicker(\""+this.pickerId+"\").selectResult(" + resultIndex + ");'>";
			for (var columnIndex=0; columnIndex<this.resultColumns.length; columnIndex++) {
				var data = nameValues[this.resultColumns[columnIndex]];				
				if (!data)
					data = "&nbsp;";
				if (columnIndex == 0)
					theHtml += "<td class='dataCell"+columnIndex+" btn btn-primary'>" + data + "</td>";
				else
					theHtml += "<td class='dataCell"+columnIndex+"'>" + data + "</td>";
			}
			theHtml += "</tr>";
		}
		if (theHtml=="" && this.isSearching) {
			theHtml += "<tr><td colspan='100%' class='noResultsMessage'>"+this.noResultsMessage+"</td></tr>";
		}
		return theHtml;
	};
	
	
	// Format:
	//   [name=value|name=value|...][name=value|name=value|...]
	//   e.g. [TestPicker-ResultAddress=blah blah|TestPicker-ResultCity=somecity|TestPicker-ResultState=SS|TestPicker-ResultZip=00000][...]
	this.prepareRequestString = function() {
		var requestString = "[";
		var needsSeparator = false;
		
		for (var index=0; index<this.searchFields.length; index++) {
			var fieldId = this.searchFields[index];
			var resolvedId = this.resolveFieldId(fieldId);
			var element = $("#"+resolvedId)[0];
			if (element) {
				var elementValue = element.value;
				if (needsSeparator)
					requestString += "|";
				requestString += this.escapeString(resolvedId) + "=" + this.escapeString(elementValue);
			}
			needsSeparator = true;
		}
		return requestString+"]";
	};
	
	
	this.parseResultsString = function() {
		// Parse each result out of the full string
		// Remove leading and trailing ] and [ characters, then look for "][" as separators
		if (this.resultList=="")
			return [];
		var tweakedResults = new String(this.resultList);
		if (tweakedResults.charAt(0) == '[')
			tweakedResults = tweakedResults.substr(1);
		if (tweakedResults.charAt(tweakedResults.length-1)==']')
			tweakedResults = tweakedResults.substr(0, tweakedResults.length-1);
		return tweakedResults.split("][");
	};
	
	
	this.parseResultData = function(resultString) {
		var resultData = resultString.split("|");
		var nameValues = {};
		for (var dataIndex=0; dataIndex<resultData.length; dataIndex++) {
			var data = resultData[dataIndex];
			var firstEqual = data.indexOf('=');
			if (firstEqual && firstEqual>1) {
				var name = this.unescapeString(data.substr(0,firstEqual));
				var value = this.unescapeString(data.substr(firstEqual+1));
				nameValues[name] = value;
			}
		}
		return nameValues;
	};
	
	this.unescapeString = function(theString) {
		if (theString) {
			theString = theString.replace("&#91;", "[");
			theString = theString.replace("&#166;", "|");
			theString = theString.replace("&#61;", "=");
			theString = theString.replace("&#93;", "]");
		}
		return theString;
	};
	
	this.escapeString = function(theString) {
		if (theString) {
			theString = theString.replace("[", "&#91;");
			theString = theString.replace("|", "&#166;");
			theString = theString.replace("=", "&#61;");
			theString = theString.replace("]", "&#93;");
		}
		return theString;
	};
	
	
	this.getFieldValue = function(elementId, splitString) {
		var value = "";
		var field = page.getField(elementId);
		if (field) {
			value = field.getValue();
			if (!value)
				value = "";
		}
		if (splitString && splitString.length>0) {
			if (value!="")
				value = value.split(splitString);
			else
				value = new Array();
		}
		return value;
	};
	
};


